// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as ActiveStorage from "@rails/activestorage"
import LocalTime from "local-time"
import Hotjar from '@hotjar/browser';

LocalTime.start()
ActiveStorage.start()


const siteId = 6394254;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);
